import React, { Component } from 'react'
import moment from 'moment'

const NOTIFICATION_TIMEOUT= 5500 //ms

class Notification extends Component {


	componentDidMount() {
		this.setTimer()
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (moment(nextProps.timestamp) !== moment(this.props.timestamp)) {
	 		//reset the timer
			this.setTimer()
		}
	}

	setTimer() {
				// clear any existing timer
		if(this._timer !== null){
			clearTimeout(this._timer)}

		// hide after `delay` milliseconds
		this._timer = setTimeout(function(){
			this.props.hideNotification()
			this._timer = null
		}.bind(this), NOTIFICATION_TIMEOUT)
	}


	render() {
		const {message,actionWord,actionType}=this.props

		return (
			<div className={'notification' + (actionType ? ` actionType--${actionType}` : ' actionType--default')}>
				<div className='notification-message'>
					{actionWord && <span className='notification-actionWord'>{actionWord} </span> }				
					{message}
				</div>
			</div>
		)
	}
}

export default Notification



// WEBPACK FOOTER //
// ./src/components/misc/Notification.js